import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Subject, ReplaySubject, Subscription, of as observableOf } from 'rxjs';
import { TemplateControlValue } from '@tamalelibs/models/template-control-value.model';
import { ValidRelationshipType } from '@tamalelibs/models/valid-relationship-type.model';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { EntityService } from '@tamalelibs/services/entity.service';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { validRelationshipTypeSelector } from '../../../../redux/reducers/valid-relationship-type.reducer';
import { catchError, take, debounceTime, filter } from 'rxjs/operators';
import { contactNewAddedJobTitleSelector } from '@tamalelibs/redux/contact.reducer';
import { ContactTemplateType, ControlId, ContactRelationshipType, ContactAction, ContactTemplateOpenOptions } from '../../../contact-dialog-new/contact-dialog.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import * as _lodash from 'lodash';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { UUID } from 'angular2-uuid';
import { RelationshipType } from '@tamalelibs/models/relationship-type.model';
import { EntryService } from '@tamalelibs/services/entry.service';
import { EntityBrief } from '@tamalelibs/models/entity-brief.model';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { EntityBack, EntityDialogOpenOptions, EntityDialogType } from '../../../entity-dialog/entity-dialog.model';
import { Contact } from '@tamalelibs/models/contact.model';
import { HomeViewModel } from '../../../../pages/home/home-view.model';
import { OpenDynamicComponentService } from '../../../../pages/home/home-open-dynamic-component';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';

@Component({
    selector: 'tam-contact-more-relationship',
    templateUrl: './contact-more-relationship.component.html',
    styleUrls: ['./contact-more-relationship.component.scss'],
    standalone: false
})
export class ContactMoreRelationshipComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;

    @Input() valueChangeSubject: ReplaySubject<TemplateControlValue>;
    @ViewChild('dropDownElCompany', { static: false }) entityElCompany;
    @ViewChild('dropDownElJobTitle', { static: false }) entityElJobTitle;
    // @ViewChild('dropDownEl', { static: false }) entityEl;

    isFly = true;
    readOnly = false; // flag to disable auto complete
    selectedDictionary: any = {}; // selected items, using dictionary for quickly removing duplicates
    inputValue = ''; // input box text value
    jobTitleSelectedItem: any; // sub set of dataItems
    jobTitleSuggestionItems: Array<any> = []; // sub set of dataItems
    jobTitleDefaultItems: Array<any> = []; // sub set of dataItems
    companySuggestionItems: Array<any> = [];
    companyDefaultItems: Array<any> = [];
    companySelectedItem = [];
    placeholder = '';
    hintContent = '';
    isMatchJobTitle = true;
    isShowCreateContact = false;
    isShowCreateEntity = false;
    isShowCreateRelationship = false;
    isHide = true;
    isAutoClose = false;
    defaultItems: Array<any> = []; // defaultItems items based on search, sub set of dataItems
    selectedItem: any; // selected items, sub set of dataItems.
    searchType = 0; // 0 company 1 jobtle 2 startY 3 endY
    readonlyTip = '';
    showCompanyError = false;
    showEndYearError = false;
    searchItem = '';

    private _defaultContactRelationshipTypes = [];
    private _relationshipType = {}; // to store the dropDown's relationship type's type: contact-all or contact
    private _validRelationshipTypes: Array<ValidRelationshipType>;
    private _filterHandler$: Subject<string> = new Subject();
    private _destroySubscriptions: Array<Subscription> = [];
    private _source: any = {}; // mark data source configuration
    private _page = 0;
    private _pageSize: number = AppConfig.searchingPageSize;
    private _dataItems: Array<any> = []; // sub set of dataItems
    private _searchValue = '';

    constructor(
        private _contactTemplateService: ContactTemplateService,
        private _entityService: EntityService,
        private _store: Store<AppState>,
        private _storeQuerier: StoreQuerierService,
        private _entryService: EntryService,
        private _homeViewModel: HomeViewModel,
        private _openDynamicComponentService: OpenDynamicComponentService,
    ) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        this._destroySubscriptions.push(
            this._store.pipe(
                select(validRelationshipTypeSelector),
                filter(res => res && res.length > 0)
            ).subscribe(res => {
                this._validRelationshipTypes = res;
                this._getRelationshipTypeSuggestionItems();
                this._initData();
                this._initRelationshipStaticValue(); // only for edit
            }),
            this._store.pipe(
                select(contactNewAddedJobTitleSelector),
                filter(res => res && res.length > 0),
            ).subscribe(res => this._handleNewAddedJobTitle(res)),

            this._filterHandler$.pipe(
                debounceTime(250),
            ).subscribe(filterStr => {
                if (filterStr && filterStr.length > 0) {
                    this._searching(filterStr);
                } else {
                    this._searching('');
                }
            }),
            this._openDynamicComponentService.feedbackSubject$.subscribe((feedback: EntityBack) => {
                const indexNumber = parseInt(feedback.currentId, 0);
                let indexString = '';
                if (indexNumber > 1) {
                    indexString = (indexNumber - 1).toString();
                }
                if (this.config.prefixId === indexString) {
                    if (feedback.controlId === this.config.controlID) {
                        this._destroySubscriptions.push(
                            this._entityService.getEntityListByIdsQuick([feedback.entityId], this._source, '')
                                .subscribe(res => this._setFlyValue(res))
                        );
                    }
                }
            }),
        );
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    handleFilter(value, index) {
        this.searchType = index;
        this._searchValue = value;
        this._filterHandler$.next(value);
    }

    onEnter(event) {
        // Handled by KendoDropdownEscFixDirective
        event.stopImmediatePropagation();
    }

    onOpen(event: any): void {
        this._searching('');
    }

    valueChangeCompany(tappedItem) {
        this._contactTemplateService.changeValueStatus = true;
        this._changeValueSet(true);
    }

    /**
     * job title change
     *
     * @param {*} tappedItem
     * @memberof ContactFormerEmploymentComponent
     */
    valueChangeJobTitle(tappedItem) {
        this._contactTemplateService.changeValueStatus = true;
        const _currentSelectedRelationshipType = {
            controlId: this.config.controlID,
            relationshipTypeId: tappedItem.id,
            relationshipTypeName: tappedItem.name,
            relationshipType: tappedItem.type,
            groupId: this.config.prefixId
        };
        this._relationshipType = _currentSelectedRelationshipType.relationshipType;
        this.clearValue();
        this.searchType = 1;
        this._searching('');
        this._changeValueSet();
        
        // Clear the job title dropdown filter text to keep it clean after selection
        setTimeout(() => {
            if (this.entityElJobTitle) {
                // Access the searchbar input directly and clear it
                const searchInput = this.entityElJobTitle.searchbar?.nativeElement;
                if (searchInput) {
                    searchInput.value = '';
                }
                // Also trigger filterChange with empty string
                if (this.entityElJobTitle.filterChange) {
                    this.entityElJobTitle.filterChange.emit('');
                }
            }
        }, 0);

    }

    clearValue() {
        // simulate user press esc this will toggle the dropdown and remove keyword on filter
        const event = new UIEvent('kendodropdown_keydown');
        event['keyCode'] = 27;
        // this.entityElCompany.keydown(event);
        this.companySelectedItem = [];
        this._changeValueSet();
    }

    clearJobTitleValue() {
        // simulate user press esc this will toggle the dropdown and remove keyword on filter
        const event = new UIEvent('kendodropdown_keydown');
        event['keyCode'] = 27;
        // this.entityElJobTitle.keydown(event);
        this.jobTitleSelectedItem = null;
        this._searching('');
        this._changeValueSet();
    }

    /**
    * Create Entity
    */
    createEntity() {
        this.showAddEntityDialog();
    }
    /**
     * Create Contact
     */
    createContact() {
        this.showAddContactDialog();
    }

    /**
     *
     *
     * @memberof ContactMoreRelationshpComponent
     */
    showAddContactDialog() {
        let index;
        this._homeViewModel.increment();
        this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
        const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
        _contactDialogOpenOptions.openType = ContactTemplateType.NewContact;
        const contact = new Contact();
        contact.name = this._searchValue;
        _contactDialogOpenOptions.contact = contact;
        const entityBack = new EntityBack();
        _contactDialogOpenOptions.instanceId = index.toString();
        entityBack.controlId = this.config.controlID;
        entityBack.searchValue = this._searchValue;
        _contactDialogOpenOptions.entityBack = entityBack;
        _contactDialogOpenOptions.isFly = true;
        this._openDynamicComponentService.openContactDialog$.next(_contactDialogOpenOptions);
    }

    showAddEntityDialog() {
        let index;
        this._homeViewModel.increment();
        this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
        const _entityDialogOpenOptions = new EntityDialogOpenOptions();
        _entityDialogOpenOptions.openType = EntityDialogType.NewEntity;
        _entityDialogOpenOptions.searchValue = this._searchValue;
        _entityDialogOpenOptions.instanceId = index.toString();
        _entityDialogOpenOptions.controlId = this.config.controlID;
        this._openDynamicComponentService.openDialog$.next(_entityDialogOpenOptions);
    }

    /**
    * add dynamic control
    *
    * @param {*} event
    * @memberof ContactCombineDropdownInputComponent
    */
    clickAddCtrol(event) {
        this.updateContorlLayout(true);
    }

    /**
     * remove dynamic control
     *
     * @param {*} event
     * @memberof ContactCombineDropdownInputComponent
     */
    clickRemoveLayout(event) {
        this.updateContorlLayout(false);
        this.selectedItem = null;
        this.inputValue = '';
    }

    updateContorlLayout(isAdd: boolean = true) {
        const newCtrlJson = _lodash.cloneDeep(this.childConfig);
        if (isAdd) {
            newCtrlJson.config.controlID = newCtrlJson.config.type + UUID.UUID();
            newCtrlJson.config.editValue = {};
            newCtrlJson.config.isCanDelete = true;
            newCtrlJson.config.isLabelHidden = true;
        }
        this._contactTemplateService.actionSubject$.next({
            type: isAdd ? ContactAction.AddControl : ContactAction.RemoveControl,
            payload: {
                ctrlType: this.config.controlType,
                ctrl: newCtrlJson,
                secSName: this.config.secSName,
                controlID: this.config.controlID,
            }
        });
    }

    selectAll() {
        this.companySelectedItem = this.companySelectedItem.concat(this.companySuggestionItems);
        const res = new Map();
        this.companySelectedItem = this.companySelectedItem.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
        this.entityElCompany.text = '';
        this._changeValueSet(true);
    }

    private _changeValueSet(isFromUser = false) {
        let value;
        let companyIdS;
        if (this.companySelectedItem) {
            companyIdS = this.companySelectedItem.map(item => item.id);
        } else {
            companyIdS = [];
        }
        const combineValue = { 'relationshipType': this.jobTitleSelectedItem ? this.jobTitleSelectedItem.id : '', 'childEntity': companyIdS };
        value = new ContactTemplateControlValue(combineValue, this.config.componentType,
            this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }

    private _handleNewAddedJobTitle(newAddedJobTitle) {
        // because the new added controlId has added the hashtime value, need to use indexOf.
        // need to get all the contact relationship type
        this._filterContactRelationship(this._validRelationshipTypes, newAddedJobTitle);

    }

    private _initData() {
        if (this.config.controlID.indexOf(ControlId.AddRelationshipEntity) !== -1) {
            if (this._relationshipType === ContactRelationshipType.ContactAll) {
                this.isShowCreateEntity = true;
                this.isShowCreateContact = false;
            } else if (this._relationshipType === ContactRelationshipType.Contact) {
                this.isShowCreateEntity = false;
                // TODO: need to support create contact
                this.isShowCreateContact = false;
            }
        }

    }

    private _initEditValue() {
        if (!this.config.editValue) {
            return;
        }
        this.selectedDictionary = {};
        this.companySelectedItem = [];
        // init for relationship entities
        if (this.config.controlID.indexOf(ControlId.Relationships) !== -1 && this.config.editValue && this.config.editValue.relationshipEntities) {
            // tslint:disable-next-line: forin
            for (const index in this.config.editValue.relationshipEntities) {
                this.selectedDictionary[this.config.editValue.relationshipEntities[index].childEntityId] = this.config.editValue.relationshipEntities[index].childEntityName;
                this.companySelectedItem.push({
                    name: this.config.editValue.relationshipEntities[index].childEntityName,
                    id: this.config.editValue.relationshipEntities[index].childEntityId
                });
            }
            // because every node in med control will have the same node type, we just need to get the first value
            this._relationshipType = this.config.editValue.relationshipEntities[0].nodeType;
            this.readOnly = !this.config.editValue.relationshipEntities[0].isNodeEditable;
            this.searchType = 1;
            this._changeValueSet(false);
        }
    }

    // this function is for edit contact
    private _initRelationshipStaticValue() {
        if (this.config.editValue && this.config.editValue.relationshipType) {
            // below part is for new added control after open the dialog, such as change the company function
            // this need to get from store
            // because if we add one control, the init has finished, and the new added control will not get the store value
            let tempValidRelationshipArray = []; // we cannot change the original array, so need to apply a new one
            if (this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).length > 0) {
                const convertNewAddedJobTitleArray = []; // need to convert the data model from the store model to the validrelationship model
                this._storeQuerier.queryBySelector(contactNewAddedJobTitleSelector).forEach(ele => {
                    convertNewAddedJobTitleArray.push({
                        relationshipType: {
                            id: ele.id,
                            name: ele.name
                        }
                    });
                });
                tempValidRelationshipArray = this._validRelationshipTypes.concat(convertNewAddedJobTitleArray);
            } else {
                tempValidRelationshipArray = this._validRelationshipTypes;
            }
            // new added control after open the dialog function is over
            if (this.config.controlID.indexOf(ControlId.Relationships) !== -1) {
                // tslint:disable-next-line: no-shadowed-variable
                tempValidRelationshipArray.forEach(element => {
                    if (element.relationshipType.id === this.config.editValue.relationshipType.relationshipTypeId) {
                        this.jobTitleSelectedItem = {
                            id: element.relationshipType.id,
                            name: element.relationshipType.name,
                            isPublic: true,
                        };
                        this.readOnly = !this.config.editValue.relationshipType.isNodeEditable;
                    }
                });
            }
            this._changeValueSet();
        }
    }

    // this function is for create and edit
    private _filterContactRelationship(relationshipTypes, newAddedJobTitle?: Array<any>) {
        this.jobTitleSuggestionItems = [];
        // tslint:disable-next-line: no-shadowed-variable
        relationshipTypes.forEach(element => {
            if ((element.childEntityType.id === EntityType.CONTACT.id &&
                element.parentEntityType.id === EntityType.CONTACT.id)) {
                this.jobTitleSuggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true,
                    type: ContactRelationshipType.ContactAll
                });
            }

            if (element.childEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id &&
                element.parentEntityType.id === EntityType.CONTACTSFORVALIDRELTYPE.id) {
                this.jobTitleSuggestionItems.push({
                    id: element.relationshipType.id,
                    name: element.relationshipType.name,
                    isPublic: true,
                    type: ContactRelationshipType.Contact
                });
            }
        });

        // this function is for new added job title when create a new job title in basic information
        if (newAddedJobTitle && newAddedJobTitle.length > 0) {
            newAddedJobTitle.forEach(item => {
                if (item.count > 0) {
                    this.jobTitleSuggestionItems.push({
                        id: item.id,
                        name: item.name,
                        isPublic: true,
                        type: ContactRelationshipType.ContactAll
                    });
                }
            });
        }

        // To fix TAM-39452 contact template performance issue. replaced lodash unique function with our own.
        // this.jobTitleSuggestionItems = _lodash.uniqWith(this.jobTitleSuggestionItems, _lodash.isEqual);
        this.jobTitleSuggestionItems = ArrayHelperService.uniqueArray(this.jobTitleSuggestionItems);
        if (this.jobTitleSuggestionItems.length !== 0) {
            this.jobTitleSuggestionItems = _lodash.sortBy(this.jobTitleSuggestionItems, item => item.name);
        }
        // for the duplicated relationship type name
        for (let i = 0, len = this.jobTitleSuggestionItems.length; i < len - 1; i++) {
            if (this.jobTitleSuggestionItems[i].name === this.jobTitleSuggestionItems[i + 1].name) {
                let currentRelationshipType = '';
                let nextRelationshipType = '';
                if (this.jobTitleSuggestionItems[i].type === ContactRelationshipType.Contact) {
                    currentRelationshipType = ' (Contact)';
                    // nextRelationshipType = ' (Entity)';
                } else {
                    // currentRelationshipType = ' (Entity)';
                    nextRelationshipType = ' (Contact)';
                }

                this.jobTitleSuggestionItems[i].name = this.jobTitleSuggestionItems[i].name + currentRelationshipType;
                this.jobTitleSuggestionItems[i + 1].name = this.jobTitleSuggestionItems[i + 1].name + nextRelationshipType;
            }
        }
        this._defaultContactRelationshipTypes = this.jobTitleSuggestionItems;
    }

    /**
     * get former job title
     *
     * @private
     * @memberof ContactFormerEmploymentComponent
     */
    private _getRelationshipTypeSuggestionItems() {
        this._filterContactRelationship(this._validRelationshipTypes);
    }

    private _searching(text) {
        switch (this.searchType) {
            case 0:
                if (text) {
                    this.jobTitleSuggestionItems = this._defaultContactRelationshipTypes.filter((item) =>
                        item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
                } else {
                    this.jobTitleSuggestionItems = this._defaultContactRelationshipTypes;
                }
                break;
            case 1:
                if (this.entityElCompany && this.entityElCompany.loading) {
                    this.entityElCompany.loading = true;
                }
                this._page = 0;
                if (this.entityElCompany) {
                    this.entityElCompany.loading = true;
                }
                if (this._relationshipType === RelationshipType.IS_IN_TEAM.name) {
                    this._destroySubscriptions.push(
                        this._entryService.getTeamsgetByParams(++this._page, this._pageSize, text, true).
                            pipe(take(1),
                                catchError((e) => {
                                    return observableOf();
                                })).subscribe(res => {
                                    if (this.entityElCompany) {
                                        this.entityElCompany.loading = false;
                                    }
                                    this.companySuggestionItems = [];
                                    // in relationship part, need to support filter by name and shortname
                                    if (res['team-list'] && res['team-list'].length > 0) {
                                        res['team-list'].filter((content) =>
                                            content['long-name'].toLowerCase().indexOf(text.toLowerCase()) !== -1 ||
                                            // tslint:disable-next-line: no-shadowed-variable
                                            content['short-name'].toLowerCase().indexOf(text.toLowerCase()) !== -1).forEach(element => {
                                                this.companySuggestionItems.push(EntityBrief.parse(element));
                                            });
                                    }
                                    this._dataItems = this.companySuggestionItems;
                                    if (this.entityElCompany) {
                                        this.entityElCompany.loading = false;
                                    }
                                }));
                } else {
                    if (this._relationshipType === ContactRelationshipType.Contact) {
                        this._source.entityType = EntityType.CONTACT.id;
                    } else {
                        this._source.entityType = '';
                    }
                    this._destroySubscriptions.push(
                        this._entityService.getEntityListBySearchTextQuick(++this._page, this._pageSize, text, this._source).
                            pipe(take(1),
                                catchError((e) => {
                                    return observableOf();
                                })).subscribe(res => {
                                    this._setStatusForCompanyControl(res, text);
                                }));
                }
        }
    }

    private _searchingDone(entityList, text) {
        this.companySuggestionItems = this._entityService.mapEntityBriefList(entityList);
        this.companyDefaultItems = this.companySuggestionItems;
        return this.companyDefaultItems;
    }

    private _setFlyValue(entityList) {
        if (entityList) {
            const item = this._entityService.mapEntityBriefList(entityList)[0];
            if (item) {
                this.companySelectedItem.push(item);
                this.companySuggestionItems.push(this.companySelectedItem);
                this.selectedDictionary[item.id] = item.name;
                this._changeValueSet(true);
            }
        }
    }

    // set status for company relatd controls
    private _setStatusForCompanyControl(res, text: string): void {
        this.searchItem = '';
        let index = -1;
        if (this.entityElCompany) {
            this.entityElCompany.loading = false;
        }
        this._dataItems = this._searchingDone(res, text);
        // in relationship part, need to support filter by name and shortname
        if (this._dataItems && this._dataItems.length > 0) {
            this.companySuggestionItems = this._dataItems.filter((content) =>
                content.name.toLowerCase().indexOf(text.toLowerCase()) !== -1 ||
                content.shortName.toLowerCase().indexOf(text.toLowerCase()) !== -1);
        }
        if (this.companySuggestionItems && this.companySuggestionItems.length > 0) {
            // For relationship part: need to get the match entity or contact
            if (this._relationshipType === ContactRelationshipType.ContactAll) {
                this.companySuggestionItems = this.companySuggestionItems.filter(item => item.type.id !== EntityType.CONTACT.id &&
                    item.type.id !== EntityType.USER.id);
                this.isShowCreateEntity = true;
                this.isShowCreateContact = false;
            } else if (this._relationshipType === ContactRelationshipType.Contact) {
                this.companySuggestionItems = this.companySuggestionItems.filter(item => item.type.id === EntityType.CONTACT.id);
                this.isShowCreateContact = true;
                this.isShowCreateEntity = false;
            }
            index = this.companySuggestionItems.findIndex((content) => content.name.toLowerCase() === text.toLowerCase() || content.shortName.toLowerCase() === text.toLowerCase());
        }
        if (index < 0 && text) {
            this.searchItem = text;
        }

        if (this.entityElCompany) {
            this.entityElCompany.loading = false;
        }
    }
}
